import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import FloatingCTA from "@/components/FloatingCTA";

export default function Layout({ children, seoTitle, seoDescription }) {
  const loc = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [loc.pathname]);

  useEffect(() => {
    if (seoTitle) document.title = `${seoTitle} — MAD TURBO`;
    else document.title = "MAD TURBO — More Boost. More Madness.";
    if (seoDescription) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", seoDescription);
    }
  }, [seoTitle, seoDescription]);

  // Global reveal-on-scroll
  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      document.querySelectorAll(".mt-reveal").forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );
    document.querySelectorAll(".mt-reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [loc.pathname]);

  const isAdmin = loc.pathname.startsWith("/admin");

  return (
    <div className="App relative">
      {!isAdmin && <Navbar />}
      <main id="main" className={isAdmin ? "" : "pt-16 md:pt-20"}>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <CookieBanner />}
      {!isAdmin && <FloatingCTA />}
    </div>
  );
}
